import {css, useTheme} from '@mui/material';
import {
  ConfigObjectType,
  DlMuiComponentBox,
  DlMuiRiskScoreFrame,
  GetStylesFunction,
  IconHeaderWithSearch,
  TypeWithEtag,
  useLocalStorage,
} from '@wallaby-ui/core';
import {MerieSchema, hospitalizationsContainer} from '@wallaby-ui/document';
import * as React from 'react';

export const PATIENT_CARD_TOP_MARGIN_PX = '74';

interface OwnProps {
  storageIdPrefix: string;
  data: TypeWithEtag<MerieSchema.components['schemas']['PatientCardDto']>;
  reloadPatientCard: () => void;
  config: ConfigObjectType;
  isCommentsMaximized: boolean;
  setIsCommentsMaximized: (newValue: boolean) => void;
}

type Props = OwnProps;

export const PatientCardLayout: React.FC<Props> = (props) => {
  const {storageIdPrefix, data, reloadPatientCard, config, isCommentsMaximized, setIsCommentsMaximized} = props;
  const theme = useTheme();

  const styles = getStyles({
    theme,
    params: {isCommentsMaximized},
  });

  const [defaultScroll, setDefaultScroll] = useLocalStorage(`${storageIdPrefix}.patientCardScroll`, 0);

  return (
    <div
      css={styles.wrapper}
      style={{
        height: isCommentsMaximized ? '100%' : undefined,
      }}
    >
      <div css={styles.riskScoreFrameWrapper}>
        <DlMuiRiskScoreFrame data={data} />
      </div>
      <IconHeaderWithSearch />
      <DlMuiComponentBox
        noTopPadding
        defaultScroll={defaultScroll}
        onScroll={(event) => {
          setDefaultScroll((event.target as HTMLDivElement).scrollTop);
        }}
      >
        <hospitalizationsContainer.PatientCard
          storageIdPrefix={storageIdPrefix}
          patientCardData={data}
          reloadPatientCard={reloadPatientCard}
          config={config}
          isCommentsMaximized={isCommentsMaximized}
          setIsCommentsMaximized={setIsCommentsMaximized}
        />
      </DlMuiComponentBox>
    </div>
  );
};

PatientCardLayout.displayName = 'PatientCardLayout';

const getStyles: GetStylesFunction = (options) => {
  return {
    wrapper: css`
      margin-top: ${PATIENT_CARD_TOP_MARGIN_PX}px;
      max-height: calc(100% - ${PATIENT_CARD_TOP_MARGIN_PX}px);
      background-color: ${options?.theme?.palette.common.white};
      display: flex;
      flex-direction: column;
      padding: ${options?.theme?.spacing(4)};
      align-items: flex-start;
      align-self: stretch;
      border-radius: ${options?.theme?.spacing(6)};
      overflow: hidden;
      color: ${options?.theme?.palette.custom.coolGray['900']};
    `,
  };
};
